import { render } from "./IconKey.vue?vue&type=template&id=38a2670a"
import script from "./IconKey.vue?vue&type=script&lang=js"
export * from "./IconKey.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__